import { render, staticRenderFns } from "./_studentCard.vue?vue&type=template&id=2280bc83&"
import script from "./_studentCard.vue?vue&type=script&lang=js&"
export * from "./_studentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports